module.exports = __webpack_public_path__ + "img/device_icon_title_purple.2b8452f9.svg";